import React, { Fragment } from 'react'

const ELDFleetView = () => {

  return (
    <Fragment>
      <iframe loading="lazy" style={{ width: "100%", height: "calc(100% - 10px)" }} src="https://login.eldfleet.com" ></iframe>
    </Fragment>
  )
}

export default ELDFleetView